import { render, staticRenderFns } from "./MultiselectCategories.vue?vue&type=template&id=8f924f24&"
import script from "./MultiselectCategories.vue?vue&type=script&lang=js&"
export * from "./MultiselectCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports